// src/components/admin/database/DatabaseDashboard.jsx
import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import {
  Groups,
  Assignment,
  Feedback,
  History // Добави икона за логове
} from '@mui/icons-material';
import ChitalishteAdmin from './ChitalishteAdmin';
import AuditLogDashboard from '../audit/AuditLogDashboard';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`database-tabpanel-${index}`}
      aria-labelledby={`database-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

const DatabaseDashboard = ({ dbAction, setDbAction }) => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Paper sx={{ width: '100%', borderRadius: 3, overflow: 'hidden' }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            backgroundColor: 'background.paper'
          }}
          TabIndicatorProps={{
            style: {
              backgroundColor: '#3f51b5',
              height: 3
            }
          }}
        >
          <Tab 
            icon={<Groups />} 
            iconPosition="start"
            label="Управление на читалища" 
            sx={{ fontSize: '1rem', py: 2, fontWeight: 600 }}
          />
          <Tab 
            icon={<History />} 
            iconPosition="start"
            label="Системни логове" 
            sx={{ fontSize: '1rem', py: 2, fontWeight: 600 }}
          />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <ChitalishteAdmin dbAction={dbAction} setDbAction={setDbAction} />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <AuditLogDashboard />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default DatabaseDashboard;